<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'BaseRouterView'
}
</script>

<style scoped>

</style>
